<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Check Cargo Stock</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <v-col cols="4">
            <v-autocomplete
              name="cargoStockStore"
              dense
              outlined
              v-model="queryStore"
              :items="stores"
              label="Select Cargo"
              item-text="Name"
              item-value="id"
              @change="queryData"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-text-field name="checkStockSearch" outlined dense label="Search" v-model="search"></v-text-field>
          </v-col>
          <v-col cols="12">
            <!-- start of table -->
            <v-data-table
              :loading="loader"
              loading-text="Loading Data......"
              :headers="headers"
              :items="inventory"
              :search="search"
            >
              <template v-slot:item.BuyingPrice="{ item }">{{ item.BuyingPrice.toLocaleString() }}</template>

              <template v-slot:item.SellingPrice="{ item }">{{ item.SellingPrice.toLocaleString() }}</template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" @click="openModal(item)" text icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- damaged template -->
              <template v-slot:item.damage="{ item }">
                <v-btn color="red" @click="openDamageModal(item)" small text>
                  <v-icon left>mdi-minus</v-icon>Record Damage
                </v-btn>
              </template>
              <!-- end -->

              <!-- damaged template -->
              <template v-slot:item.transfer="{ item }">
                <v-btn color="primary" @click="openTransferModal(item)" small text>
                  <v-icon left>mdi-alpha-t-circle-outline</v-icon>Transfer
                  Stock
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row> 
      </v-card-text>
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data() {
    return {
      search: null,
      pageItems: 500,
      loader: false,
      editItem: {},
      damagedItem: {},
      transferItem: {},
      store: null,
      queryStore: null,
      stores: [],
      users: [],
      date: null,
      dialog: false,
      damageDialog: false,
      transferDialog: false,
      headers: [
        { text: "Product Name", value: "product.Name" },
        { text: "Available Qty", value: "AvailableQty" },
      ],
      inventory: [],
    };
  },
  methods: {
    queryData() {
      const id = this.queryStore;
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("get", `/stores/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.inventory = res.ResponseData.itm2;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      const ParentID = this.activeStore;
      this.$store
        .dispatch("get", `/stores?StrType=2&ParentID=${ParentID}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.getStores()]);
  },
};
</script>

<style lang="scss" scoped>
</style>